import { Box, Card, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CardContainer = styled(Card, {
	shouldForwardProp: (prop) => prop !== 'navigable',
})<{ navigable: boolean }>(({ theme, navigable }) => ({
	borderRadius: (theme.shape.borderRadius as number) * 2,
	border: `1px solid ${theme.palette.divider}`,
	overflow: 'hidden',
	cursor: navigable ? 'pointer' : 'default',
	transition: 'all 0.2s ease',
	...(navigable && {
		'&:hover': {
			transform: 'translateY(-4px)',
			boxShadow: theme.shadows[8],
		},
	}),
}));

export const ColorStripe = styled(Box, {
	shouldForwardProp: (prop) => prop !== 'stripecolor',
})<{ stripecolor: string }>(({ stripecolor }) => ({
	height: 6,
	backgroundColor: stripecolor,
}));

export const CardBody = styled(Box)(({ theme }) => ({
	padding: theme.spacing(3),
	display: 'flex',
	flexDirection: 'column',
	gap: theme.spacing(1.5),
}));

export const CardTopRow = styled(Box)(({ theme }) => ({
	display: 'flex',
	alignItems: 'flex-start',
	justifyContent: 'space-between',
	gap: theme.spacing(1),
}));

export const EntityAvatar = styled(Box, {
	shouldForwardProp: (prop) => prop !== 'bgcolor' && prop !== 'accentcolor',
})<{ bgcolor: string; accentcolor: string }>(({ bgcolor, accentcolor }) => ({
	width: 48,
	height: 48,
	borderRadius: 10,
	backgroundColor: bgcolor,
	color: accentcolor,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	fontSize: '1rem',
	fontWeight: 700,
	letterSpacing: '0.02em',
	flexShrink: 0,
	overflow: 'hidden',
}));

export const AvatarImage = styled('img')({
	width: '100%',
	height: '100%',
	objectFit: 'cover',
	display: 'block',
});

export const ChildCountBadge = styled(Box, {
	shouldForwardProp: (prop) => prop !== 'accentcolor',
})<{ accentcolor: string }>(({ accentcolor }) => ({
	display: 'inline-flex',
	alignItems: 'center',
	gap: 4,
	padding: '3px 10px',
	borderRadius: 20,
	fontSize: '0.72rem',
	fontWeight: 700,
	backgroundColor: accentcolor + '18',
	color: accentcolor,
	whiteSpace: 'nowrap',
}));

export const CardFooter = styled(Box)(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'flex-end',
	gap: theme.spacing(0.5),
	paddingTop: theme.spacing(1.5),
	borderTop: `1px solid ${theme.palette.divider}`,
}));

export const ActionButton = styled(IconButton)(({ theme }) => ({
	width: 32,
	height: 32,
	color: theme.palette.text.secondary,
	'&:hover': {
		backgroundColor: theme.palette.action.hover,
		color: theme.palette.text.primary,
	},
}));
